module.exports = {
    banner1_text: 'အချိန်ကို ပျော်ရွှင်စရာ မကောင်းတဲ့ လူတွေနဲ့ ဖြတ်သန်းနေခြင်းဟာ တိုတောင်းတာမှုကြီးပါ။ တစ်ယောက်ခု သင့်ကို သူတို့ဘဝထဲ ထည့်သွင်းချင်ရင် သင့်အတွက် နေရာဖြစ်အောင် စီစဉ်ပေးမှာပါ။',
    leistungsumfang: 'ဝန်ဆောင်မှုပိုမိုကောင်းမွန်',
    leistungsumfang_text: 'လက်ရှိတွင် စားသုံးသူ ၁၀၀,၀၀၀ ကျော်နှင့် ကောင်းမွန်သော သုံးသပ်ချက်များ ရရှိနေပါသည်',
    leistungsumfang_free: 'အခမဲ့ လွှဲပြောင်း',
    home: 'ပင်မစာမျက်နှာ',
    about: 'အကြောင်းအရာ',
    order: 'အော်ဒါ',
    record: 'အော်ဒါမှတ်တမ်း',
    user: 'ကျွန်ုပ်၏',
    about_text1: 'အရည်အသွေးကောင်းသော 상품များ',
    about_text2: 'ထုတ်ကုန်များပိုမိုကြည့်ရန်',
    order_title: 'ယနေ့အော်ဒါ',
    zongzichan: 'စုစုပေါင်းပိုင်နက်',
    jinridan: 'ယနေ့အော်ဒါအရေအတွက်',
    tiyanjin: 'အတွေ့အကြုံငွေ',
    jinrishou: 'ယနေ့ဝင်ငွေ',
    tip: 'မှတ်ချက်',
    jintuandui: 'ယနေ့အသင်းဖွဲ့ကော်မရှင်',
    dianjigou: 'စတင်တာဝန်ယူရန်',
    wallet_amount:'အိတ်ပိုက်ပမာဏ',
    credibility_value:'ယုံကြည်စိတ်ချရမှုတန်ဖိုး',
    the_system_automatcally_update_the_daily_earnings:'စနစ်သည် နေ့စဉ်ဝင်ငွေကို အလိုအလျောက် update လုပ်သည်။',
    today_profit:'ယနေ့ အမြတ်',
    adianjigou: 'တင်သွင်းရန်',
    order_illustrate: 'ငွေမှားယွင်းစွာ သင့်ဘဏ်အကောင့်သို့ လွှဲပြောင်းပါက ပလက်ဖောင်းက တာဝန်မယူပါ။ အနည်းဆုံး ဆုပေါင် ၅၀,၀၀၀ ဖြစ်ရပါမည်။',
    order_record: 'အော်ဒါမှတ်တမ်း',
    all: 'အားလုံး',
    for_further_assistance_please_contact_customer_care: 'လိုအပ်ပါသည်။ ကျေးဇူးတင်ပါသည်။',
    important_notice: 'မှတ်ချက်အချိန်',
    business_hours: 'အချိန်ကို ပျော်ရွှင်စရာ မကောင်းတဲ့ လူတွေနဲ့ ဖြတ်သန်းနေခြင်းဟာ တိုတောင်းတာမှုကြီးပါ။',
    every_ratings_profit_will_add_to_total_assets_balance: 'အော်ဒါရေးငွေ သင့်အတွက် နေရာဖြစ်အောင် စီစဉ်ပေးမှာပါ။',
        it_will_be_updated_daily_only_todays_profits_are_shown_here:' ၎င်းကို နေ့စဉ် ပြန်လည်အသုံးပြုမည်။ ဒီမှာ ဒီနေ့ အမြတ်တွေသာ ပြထားတယ်။',
    vip_level: 'အခမဲ့အသွေး',
    revenue_per_order: 'အော်ဒါရေးငွေ',
    orders_can_be_received_per_day: 'ယနေ့အော်ဒါများ',
    mission_deposit: 'မис်ပွန်လုပ်ငန်း',
    undone: 'မပြီးသေးသော',
    completed: 'ပြီးပြည့်စုံသော',
    score: 'ရမှတ်',
    benutzer: 'အသုံးပြုသူ',
    chongzhi: 'ဖြည့်တည့်ရန်',
    tixian: 'ငွေထုတ်ယူရန်',
    details: 'အကောင့်အသေးစိတ်',
    password: 'စကားဝှက်စီမံခန့်ခွဲမှု',
    password_jy: 'ငွေကြေးစကားဝှက်',
    notify: 'စနစ်အသိပေးချက်',
    kefu: 'စာမေးခွန်းဝန်ထမ်း',
    bank_card: 'ဘဏ်ကဒ်',
    invite: 'သူငယ်ချင်းများဖိတ်ခေါ်ရန်',
    team: 'အသင်းဖွဲ့အစီရင်ခံစာ',
    language: 'ဘာသာစကားရွေးချယ်ရန်',
    member: 'အသင်းဝင်တိုးတက်ရေး',
    balance: 'အကောင့်စာရင်းကျန်',
    quit: 'ထွက်ခွာရန်',
    invite_text1: 'သူငယ်ချင်းကိုဖိတ်ပြီး ငွေရှာယူရန်',
    invite_code: 'ဖိတ်ကြားမှုကုဒ်',
    invite_btn: 'ဖိတ်ကြားမှုလင့်ခ်: ကလစ်နှိပ်ပြီး ကူးယူရန်',
    copy_s: 'ကူးယူမှုအောင်မြင်သည်',
    copy_b: 'ကူးယူမှုမအောင်မြင်ပါ',
    grade: 'အသင်းဝင်အဆင့်',
    my_money: 'ကျွန်ုပ်၏အကောင့်စာရင်းကျန်',
    open_member: 'အသင်းဝင်ဖြစ်အောင် သတ်မှတ်ရန်',
    withdraw_num: 'ငွေထုတ်ယူမှုအကြိမ်ရေ',
    day: 'ရက်',
    withdraw_quota: 'ငွေထုတ်ယူနိုင်မှုပမာဏ',
    order_num: 'အော်ဒါအရေအတွက်',
    profit_scale: 'ကော်မရှင်အချိုး',
    member_time: 'အသင်းဝင်အချိန်မကုန်ဘဲ',
    confirm_pay: 'ငွေပေးချေမှုအတည်ပြုရန်',
    order_sub: 'အော်ဒါတင်သွင်းရန်',
    user_info: 'အသုံးပြုသူအချက်အလက်',
    avatar: 'ပရိုဖိုင်းပုံ',
    username: 'အသုံးပြုသူအမည်',
    set_up: 'ချက်ချင်းသတ်မှတ်ရန်',
    revise_name: 'အမည်ပြောင်းရန်',
    username_hint: 'အသုံးပြုသူအမည်ဖြည့်စွက်ပေးပါ',
    user_account: 'အသုံးပြုသူအကောင့်',
    add_money: 'ဖြည့်တည့်ရန်',
    add_money_num: 'ဖြည့်တည့်မည့်ပမာဏ',
    add_money_hint1: '၁။ ငွေပေးချေမှုပမာဏသည် အော်ဒါပမာဏနှင့် တူညီရမည်၊ မဟုတ်ပါက အလိုအလျောက် မရောက်ရှိလာမည် မဟုတ်ပါ',
    add_money_hint2: '၂။ ဖြည့်တည့်မှုနှင့် ငွေထုတ်ယူမှုမရရှိပါက သင့်အပေါ်တန်းဆင့် သို့မဟုတ် စာမေးခွန်းဝန်ထမ်းကို ဆက်သွယ်ပြီး အခက်အခဲအား ဖြေရှင်းပေးရန်',
    add_money_hint3: 'ခံကြေးနှင့်ပတ်သက်၍ စာမေးခွန်းဝန်ထမ်းကိုဆက်သွယ်ပါ',
    add_money_record: 'ဖြည့်တည့်မှုမှတ်တမ်း',
    withdraw_record: 'ငွေထုတ်ယူမှုမှတ်တမ်း',
    withdraw_money: 'ငွေထုတ်ယူမည့်ပမာဏ',
    can_withdraw_money: 'ငွေထုတ်ယူနိုင်သောပမာဏ',
    order_number: 'စဉ်နံပါတ်',
    money: 'ပမာဏ',
    bank: 'ဘဏ်',
    transaction_flow: 'ငွေလွှဲစဉ်နံပါတ်',
    already_paid: 'ငွေပေးပြီးပါပြီ',
    upload_pay_img: 'ငွေပေးချေမှုပုံထည့်ရန်',
    order_details: 'အကောင့်အသေးစိတ်',
    old_password: 'အဟောင်းစကားဝှက်',
    new_password: 'စကားဝှက်အသစ်',
    repeat_password: 'စကားဝှက်ပြန်လည်ရိုက်ထည့်ရန်',
    enter: 'ဖြည့်စွက်ပေးပါ',
    password_hint: 'စကားဝှက်ကို မှတ်ထားပေးပါ၊ စကားဝှက်မေ့သွားပါက စာမေးခွန်းဝန်ထမ်းကိုဆက်သွယ်ပါ',
    submit: 'တင်သွင်းရန်',
    bankCard: 'ဘဏ်ကဒ်ချိတ်ဆက်ရန်',
    bank: 'ဘဏ်အမည်',
    bank_card_num: 'ဘဏ်ကဒ်နံပါတ်',
    bank_card_name: 'ကဒ်ပိုင်ရှင်အမည်',
    team: 'အသင်းဖွဲ့အစီရင်ခံစာ',
    today: 'ယနေ့',
    yesterday: 'မနေ့က',
    week: 'ဤအပတ်',
    scale: 'အချိုး',
    team_people: 'အသင်းဖွဲ့အရေအတွက်',
    team_order_scale: 'အသင်းဖွဲ့အော်ဒါကော်မရှင်',
    open_bank_name: 'ဘဏ်အကောင့်အမည်',
    phone: 'စာရင်း',
    user_password: 'စကားဝှက်',
    login: 'ဝင်ရောက်ရန်',
    register: 'မှတ်ပုံတင်ရန်',
    password_qr: 'စကားဝှက်အတည်ပြုရန်',
    pwd_no_same: 'စကားဝှက်မတူညီပါ',
    loading: 'ဖွင့်နေသည်',
    freeze: 'ပိတ်ဆို့ထားသည်',
    pending: 'စောင့်ဆိုင်းနေသည်',
    order_hao: 'အော်ဒါနံပါတ်',
    order_time: 'အော်ဒါရယူချိန်',
    price: "တစ်ခုချင်းစီဈေးနှုန်း",
    order_total_price: 'အော်ဒါစုစုပေါင်းပမာဏ',
    scale: 'ကော်မရှင်',
    level: 'အသင်းဝင်အဆင့်',
    level_up: 'အသင်းဝင်တိုးတက်ရေး',
    pay_way: 'ဖြည့်တည့်မှုနည်းလမ်း',
    money_min: 'ပမာဏအနည်းငယ်',
    pay_no: 'ဖြည့်တည့်မှုနည်းလမ်းကိုရွေးချယ်ပေးပါ',
    // အသစ်ထည့်သွင်းထားသော
    team_all: 'အားလုံး',
    team_yi: 'ပထမအဆင့်',
    team_er: 'ဒုတိယအဆင့်',
    team_san: 'တတိယအဆင့်',
    close_order: 'အော်ဒါပယ်ဖျက်ရန်',
    shouru: 'ဝင်ငွေ',
    zhichu: 'ထွက်ငွေ',
    welcome: 'ကြိုဆိုပါသည်',
    account_amount: 'အကောင့်စာရင်းကျန်',
    History: 'ငွေလွှဲမှတ်တမ်း',
    Deposit: 'ဖြည့်တည့်ရန်',
    // အသစ်ထည့်သွင်းထားသော၂
    order_kong: 'အော်ဒါနံပါတ်များ မဖြစ်နိုင်ပါ',
    quer: 'အတည်ပြုရန်',
    quxiao: 'ပယ်ဖျက်ရန်',
    qianbaodi: 'ပိုကက်စာအိတ်လိပ်စာ',
    xingming: 'အမည်',
    bank_chong: 'ထပ်တူချိတ်ဆက်၍မရပါ',
    introduce: 'ကုမ္ပဏီမိတ်ဆက်',
    platform: 'ပလက်ဖောင်းစည်းမျဉ်းများ',
    tixianzhang: 'ငွေထုတ်ယူမှုအမျိုးအစား',
    xuanze: 'ကျေးဇူးပြု၍ရွေးချယ်ပေးပါ',
    xiayiye: 'နောက်စာမျက်နှာကိုဖွင့်ရန် ကလစ်နှိပ်ပါ',
    deposit: 'ဖြည့်တည့်ရန်',
    withdraw_acount: 'ငွေထုတ်ယူမှုအကောင့်',
    Deposit_Now: 'ဖြည့်တည့်ရန်',
    Deposit_Amount: 'ဖြည့်တည့်မည့်ပမာဏ',
    personal_info: 'ကိုယ်ရေးအချက်အလက်',
    waiting_for_merchant_response:'ကုန်သည်တုံ့ပြန်မှုကို စောင့်နေသည်...',
    quer:'အတည်ပြုရန်',
    quxiao:'ပယ်ဖျက်ရန်',
    waiting_for_merchant_response:'တုံ့ပြန်မှုကို စောင့်နေသည်...'
}